/**
 * BillingAccountAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Currency } from './currency';
import { EntityStatus } from './entityStatus';
import { FromEngine } from './fromEngine';
import { Status } from './status';

export interface ResourceTransactionLog { 
    id?: string;
    transactionId?: string;
    operationCount?: number;
    seconds?: number;
    resourceId?: string;
    clientId?: string;
    clientResourceId?: string;
    transactionTime?: Date;
    createdDate?: Date;
    terminatedOn?: Date;
    entityStatus?: EntityStatus;
    amount?: number;
    vat?: number;
    rate?: number;
    currency?: Currency;
    status?: Status;
    fromEngine?: FromEngine;
    systemIdentifier?: string;
    authId?: string;
}